import React, { useRef } from 'react';
import { TextField, InputLabel, Typography, Alert, Card } from '@mui/material';

function LabDescription(props) {
    const MAX_DESCRIPTION_LENGTH = 1000; // Limite massimo descrizione desktop pool Omnissa Horizon (max API: 1024)
    const FORBIDDEN_CHARS = /["<>\\&']/g; // Caratteri non ammessi da Omnissa Horizon 2512
    const targetBadDescriptionAlert = useRef(null);
    const {
        isLabdescriptionSpellChecked,
        setIsLabdescriptionSpellChecked,
        setLabDescription,
    } = props;

    const [charCount, setCharCount] = React.useState(0);
    const [hasForbiddenChars, setHasForbiddenChars] = React.useState(false);

    const labDescriptionHandler = (event) => {
        let labDesc = event.target.value;
        const hadForbidden = FORBIDDEN_CHARS.test(labDesc);
        setHasForbiddenChars(hadForbidden);
        const sanitizedValue = labDesc.replace(FORBIDDEN_CHARS, '').substring(0, MAX_DESCRIPTION_LENGTH);

        setCharCount(sanitizedValue.length);

        if (sanitizedValue.length > MAX_DESCRIPTION_LENGTH) {
            setIsLabdescriptionSpellChecked(false);
        } else {
            setIsLabdescriptionSpellChecked(true);
            setLabDescription(sanitizedValue);
        }

        event.target.value = sanitizedValue;
    }

    return (
        <Card sx={{ padding: 3 }}>
            <InputLabel>Descrizione del Laboratorio Virtuale</InputLabel>
            <Typography variant="body2" color="textSecondary">
                <b>Dato obbligatorio</b> (max {MAX_DESCRIPTION_LENGTH} caratteri)
            </Typography>
            <TextField
                fullWidth
                type="text"
                onChange={labDescriptionHandler}
                placeholder="Descrizione del Laboratorio"
                variant="outlined"
                margin="normal"
                inputRef={targetBadDescriptionAlert}
                required
                error={!isLabdescriptionSpellChecked}
                inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                helperText={`${charCount}/${MAX_DESCRIPTION_LENGTH}`}
            />

            {!isLabdescriptionSpellChecked &&
                <Alert severity="warning">
                    Attenzione! La descrizione supera il limite massimo di {MAX_DESCRIPTION_LENGTH} caratteri.
                </Alert>
            }
            {hasForbiddenChars &&
                <Alert severity="warning">
                    I caratteri {'" < > \\ & \''} non sono ammessi e sono stati rimossi automaticamente.
                </Alert>
            }
        </Card>
    );
}

export default LabDescription;